import React, { useEffect, useState } from "react";
import InputField from "../../../common/components/FormFields/InputField";
import { Divider, Tooltip } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { useEMRGeneralContext } from "../newGeneralEmr/EMRContextGeneral";
import GynacVitalChart from "./VitalChart";
import { VitalChart } from "./EmrCommonAsset/Asset";

function VitalNew(props) {
  const { isDirty, setIsDirty, weight, setWeight, height, setHeight, data } =
    props;
  const [openViewVitals, setOpenViewVital] = useState(false);
  const {
    control,
    watch,
    register,
    handleSubmit,
    setValue,
    setError,
    formState: { errors },
  } = useFormContext({
    mode: "onChange",
  });
  let heightCmswatch = watch("height");
  let weightCmswatch = watch("weight");
  console.log("datadatadatadatadatadata", heightCmswatch, weightCmswatch);

  useEffect(() => {
    if (
      heightCmswatch !== undefined &&
      heightCmswatch !== "" &&
      heightCmswatch !== null &&
      weightCmswatch !== undefined &&
      weightCmswatch !== "" &&
      weightCmswatch !== null
    ) {
      const calculatedBsa = Math.sqrt((heightCmswatch * weightCmswatch) / 3600);
      setValue("bsa", calculatedBsa.toFixed(2));
    }
  }, [heightCmswatch, weightCmswatch]);

  useEffect(() => {
    if (
      heightCmswatch !== undefined &&
      heightCmswatch !== "" &&
      heightCmswatch !== null &&
      weightCmswatch !== undefined &&
      weightCmswatch !== "" &&
      weightCmswatch !== null
    ) {
      const calculatedBmi =
        weightCmswatch / ((heightCmswatch / 100) * (heightCmswatch / 100));
      console.log("calculatedBmi", calculatedBmi);

      setValue(
        "bmi",
        calculatedBmi !== NaN
          ? calculatedBmi.toFixed(2)
          : calculatedBmi === NaN
          ? 0
          : ""
      );
    }
  }, [heightCmswatch, weightCmswatch]);
  return (
    <div>
      <div className="flex justify-between bg-[#FFD4E3] rounded-t-md">
        <p className="text-sm font-semibold w-full pl-2 py-2">
          Vitals/General Examinations
        </p>
        <div className="mt-2 mr-2">
          {props.from === "Wellness" && (
            <Tooltip title="Vitals Charts" placement="top-start" arrow>
              <button
                type="button"
                onClick={() => {
                  setOpenViewVital(true);
                }}
              >
                <VitalChart />
              </button>
            </Tooltip>
          )}
        </div>
      </div>
      <div
        className={`${
          props.from === "Wellness" ? "" : ""
        } flex justify-between   border p-2  border-[#D9D9D9] rounded-b-md bg-white `}
      >
        <div
          className={`grid ${
            props?.showVisits === true
              ? `md:grid-cols-3 xl:grid-cols-7`
              : `md:grid-cols-5 xl:grid-cols-9`
          } gap-x-2 gap-y-2 pt-1`}
        >
          <div className="flex space-x-3">
            <fieldset
              className="w-full"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            >
              <InputField
                // disabled={data !== null}

                type="number"
                control={control}
                name="weight"
                label="Weight(Kg)"
                inputRef={{
                  ...register("weight", {
                    onChange: (e) => {
                      setWeight(e.target.value);
                      if (Number(e.target.value) > 300) {
                        setIsDirty(true);
                      } else {
                        setIsDirty(false);
                      }
                    },
                  }),
                }}
                error={
                  watch("weight") > 300 ? { message: "Wrong Pulse Rate" } : null
                }
              />
            </fieldset>
          </div>
          <div className="flex space-x-3">
            <fieldset
              className="w-full"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            >
              <InputField
                // disabled={data !== null}

                type="number"
                control={control}
                name="height"
                label="Height(cm)"
                inputRef={{
                  ...register("height", {
                    onChange: (e) => {
                      setHeight(e.target.value);
                      if (Number(e.target.value) > 500) {
                        setIsDirty(true);
                      } else {
                        setIsDirty(false);
                      }
                    },
                  }),
                }}
                error={
                  watch("height") > 500 ? { message: "Wrong Pulse Rate" } : null
                }
              />
            </fieldset>
          </div>
          <div className="flex space-x-3">
            <InputField disabled control={control} name="bmi" label="BMI" />
          </div>
          <div className="flex space-x-3">
            <fieldset
              className="w-full"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            >
              <InputField
                // disabled={data !== null}

                type="number"
                control={control}
                name="bpSystolic"
                label="BP (S) mmHg)"
                inputRef={{
                  ...register("bpSystolic", {
                    onChange: (e) => {
                      if (Number(e.target.value) > 500) {
                        setIsDirty(true);
                      } else {
                        setIsDirty(false);
                      }
                    },
                  }),
                }}
                error={
                  watch("bpSystolic") > 500
                    ? { message: "Wrong Pulse Rate" }
                    : null
                }
              />
            </fieldset>
          </div>
          <div className="flex space-x-3">
            <fieldset
              className="w-full"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            >
              <InputField
                // disabled={data !== null}

                type="number"
                control={control}
                name="bpDiastolic"
                label="BP (D)(mmHg)"
                inputRef={{
                  ...register("bpDiastolic", {
                    onChange: (e) => {
                      if (Number(e.target.value) > 500) {
                        setIsDirty(true);
                      } else {
                        setIsDirty(false);
                      }
                    },
                  }),
                }}
                error={
                  watch("bpDiastolic") > 500
                    ? { message: "Wrong Pulse Rate" }
                    : null
                }
              />
            </fieldset>
          </div>
          <div className="flex space-x-3">
            <fieldset
              className="w-full"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            >
              <InputField
                // disabled={data !== null}
                type="number"
                control={control}
                name="temp"
                label="Temp(°F)"
                inputRef={{
                  ...register("temp", {
                    onChange: (e) => {
                      if (Number(e.target.value) > 200) {
                        setIsDirty(true);
                      } else {
                        setIsDirty(false);
                      }
                    },
                  }),
                }}
                error={
                  watch("temp") > 200 ? { message: "Wrong Temperature" } : null
                }
              />
            </fieldset>
          </div>

          <div className="flex space-x-3">
            <fieldset
              className="w-full"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            >
              <InputField
                // disabled={data !== null}

                type="number"
                control={control}
                name="pulseRate"
                label="Pulse (bpm)"
                inputRef={{
                  ...register("pulseRate", {
                    onChange: (e) => {
                      if (Number(e.target.value) > 220) {
                        setIsDirty(true);
                      } else {
                        setIsDirty(false);
                      }
                    },
                  }),
                }}
                error={
                  watch("pulseRate") > 220
                    ? { message: "Wrong Pulse Rate" }
                    : null
                }
              />
            </fieldset>
          </div>
          <div className="flex space-x-3">
            <fieldset
              className="w-full"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            >
              <InputField
                // disabled={data !== null}

                type="number"
                control={control}
                name="spO2"
                label="SpO2(%)"
                inputRef={{
                  ...register("spO2", {
                    onChange: (e) => {
                      if (Number(e.target.value) > 100) {
                        setIsDirty(true);
                      } else {
                        setIsDirty(false);
                      }
                    },
                  }),
                }}
                error={
                  watch("spO2") > 100 ? { message: "Wrong Pulse Rate" } : null
                }
              />
            </fieldset>
          </div>

          <div className="flex space-x-3">
            <fieldset
              className="w-full"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            >
              <InputField
                // disabled={data !== null}

                type="number"
                control={control}
                name="respiration"
                label="Resp(min)"
                inputRef={{
                  ...register("respiration", {
                    onChange: (e) => {
                      if (Number(e.target.value) > 100) {
                        setIsDirty(true);
                      } else {
                        setIsDirty(false);
                      }
                    },
                  }),
                }}
                error={
                  watch("respiration") > 100
                    ? { message: "Wrong Pulse Rate" }
                    : null
                }
              />
            </fieldset>
            {/* <Divider orientation='vertical' /> */}
          </div>

          <div className="flex space-x-3">
            <InputField
              type="number"
              disabled
              control={control}
              name="bsa"
              label="BSA(m²)"
            />
          </div>
          <div className="flex space-x-3">
            <fieldset
              className="w-full"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            >
              <InputField
                type="number"
                control={control}
                name="bsl"
                label="Blood Suger Level"
                inputRef={{
                  ...register("bsl", {
                    onChange: (e) => {},
                  }),
                }}
              />
            </fieldset>
          </div>
          <div className="mb-2">
            <InputField
              control={control}
              name="fundalHeight"
              label="Fundal Height (In Weeks)"
            />
          </div>
          <div className="mb-2">
            <InputField
              control={control}
              name="presentation"
              label="Presentation"
            />
          </div>

          {/* <div className="mb-2">
              <InputField control={control} name="fhs" label="FHS" />
            </div> */}
          <div className="mb-2">
            <InputField control={control} name="pallor" label="Pallor" />
          </div>
          <div className="mb-2">
            <InputField control={control} name="edema" label="OEDEMA" />
          </div>
          <div className="flex space-x-3">
            <fieldset
              className="w-full"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            >
              <InputField
                control={control}
                name="icterus"
                label="ICTERUS"
                inputRef={{
                  ...register("bsl", {
                    onChange: (e) => {},
                  }),
                }}
              />
            </fieldset>
          </div>
          <div className="flex space-x-3">
            <fieldset
              className="w-full"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            >
              <InputField
                control={control}
                name="cyanosis"
                label="CYANOSIS"
                inputRef={{
                  ...register("bsl", {
                    onChange: (e) => {},
                  }),
                }}
              />
            </fieldset>
          </div>
          <div className="flex space-x-3">
            <fieldset
              className="w-full"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            >
              <InputField
                control={control}
                name="urineAlbumin"
                label="Urine Albumin"
                inputRef={{
                  ...register("bsl", {
                    onChange: (e) => {},
                  }),
                }}
              />
            </fieldset>
          </div>
          {/* <div className="mb-2">
              <InputField control={control} name="ua" label="U/A" />
            </div> */}
          {/* <div className="mb-2">
              <InputField
                control={control}
                name="varginalExam"
                label="Vaginal Exam"
              />
            </div> */}
        </div>
      </div>
      <GynacVitalChart
        openViewVitals={openViewVitals}
        setOpenViewVital={setOpenViewVital}
        patientId={props.patientId}
        weight={weight}
        setWeight={setWeight}
        height={height}
        setHeight={setHeight}
      />
    </div>
  );
}

export default VitalNew;

